
    <div class="modal-dialog {{(modalOptions.size ? ' modal-' + modalOptions.size : '')}}" role="document"><div class="modal-content"><re-modal-content #modalContent></re-modal-content></div></div>
  